import { render, staticRenderFns } from "./List01.vue?vue&type=template&id=01b0169b&scoped=true&"
import script from "./list01.js?vue&type=script&lang=js&"
export * from "./list01.js?vue&type=script&lang=js&"
import style0 from "./List01.vue?vue&type=style&index=0&id=01b0169b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b0169b",
  null
  
)

export default component.exports